<template>
  <div class="paymentMethod">
    <div class="paymentMethod_header">
      <h1>Payment Method</h1>
    </div>
    <div class="frameParent" v-if="paymentMethod">
      <div class="frameGroup">
        <div class="dateWrapper">
          <div class="date">Date</div>
        </div>
        <div class="type">Type</div>
        <div class="paymentMethod">Payment method</div>
      </div>
      <div class="frameContainer">
        <div class="dateWrapper">
          <div class="date">
            {{ paymentMethod.updatedAt.format("MM/DD/YYYY hh:mm:ss") }}
          </div>
        </div>
        <div class="visa">{{ paymentMethod.provider }}</div>
        <div class="paymentMethod">{{ paymentMethod.displayNumber }}</div>
        <div class="changePaymentMethod" @click="changePaymentMethod">
          Change Payment Method
        </div>
        <img
          class="dottedIcon"
          alt=""
          src="/static/img/dotted.svg"
          @click="toggleDropdown"
        />
        <div v-if="dropdownOpen" class="methodDropdown">
          <button class="dropdownButton" @click="editPaymentMethod">
            Edit
          </button>
          <button class="dropdownButton" @click="preDelete">Delete</button>
        </div>
      </div>
      <button @click="createNewPaymentMethod">Add Payment Method</button>
    </div>
    <payment-method-modal
      :is-visible="modalOpen"
      :mode="modalMode"
      :payment-method="paymentMethod"
      :key="modalKey"
      :all-payment-methods="
        allPaymentMethods.filter((data) => data.id !== paymentMethod.id)
      "
      @close="modalOpen = false"
      @select="selectPaymentMethod"
      @update="getAll"
    ></payment-method-modal>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { useLoginStore } from "../../../../../../stores/loginStore";
import PaymentMethodModal from "../PaymentMethodModal.vue";
import InvoicesAPIService from "../../../../../../servicehandlers/InvoiceAPIService";
import PaymentMethodsAPIService from "../../../../../../servicehandlers/PaymentMethodsAPIService";

const invoiceAPIService = new InvoicesAPIService();
const paymentMethodsAPIService = new PaymentMethodsAPIService();
export default {
  name: "PaymentMethod",
  components: {
    PaymentMethodModal,
  },
  data() {
    return {
      paymentMethod: null,
      flightSchoolId: useLoginStore().getUser.flightSchoolId,
      dropdownOpen: false,
      modalOpen: false,
      modalMode: "",
      invoiceSettings: null,
      modalKey: 0,
      allPaymentMethods: [],
    };
  },
  async mounted() {
    await this.getAll();

    document.addEventListener("click", this.handleClick);
  },
  methods: {
    async getAll() {
      await this.getPaymentMethod();
      await this.getAllPaymentMethodsForSchool();
    },
    getPaymentMethod() {
      return invoiceAPIService
        .getInvoiceSettingsForSchool(this.flightSchoolId, this.$router)
        .then((response) => {
          this.invoiceSettings = response;
          this.paymentMethod = response.paymentMethod;

          switch (this.paymentMethod.billingType.name) {
            case "Credit Card":
              this.paymentMethod.displayNumber = "**** ";
              break;
            case "Account":
              this.paymentMethod.displayNumber = "**";
              break;
          }
          this.paymentMethod.displayNumber += this.paymentMethod.lastFourDigits;
          this.paymentMethod.updatedAt = dayjs(this.paymentMethod.updatedAt);
          this.paymentMethod.name =
            this.paymentMethod.provider +
            " " +
            this.paymentMethod.lastFourDigits;
        });
    },
    getAllPaymentMethodsForSchool() {
      return paymentMethodsAPIService
        .getAllPaymentMethodsForSchool(this.flightSchoolId, this.$router)
        .then((response) => {
          this.allPaymentMethods = response;
          for (let method of this.allPaymentMethods) {
            method.name = method.provider + " " + method.lastFourDigits;
          }
        });
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    handleClick(event) {
      if (
        !event.target.closest(".methodDropdown") &&
        !event.target.closest(".dottedIcon")
      ) {
        this.dropdownOpen = false;
      }
    },
    createNewPaymentMethod() {
      this.modalKey = Date.now();
      this.modalMode = "Create";
      this.modalOpen = true;
    },
    editPaymentMethod() {
      this.modalKey = Date.now();
      this.modalMode = "Edit";
      this.modalOpen = true;
      this.dropdownOpen = false;
    },
    changePaymentMethod() {
      this.modalKey = Date.now();
      this.modalMode = "Change";
      this.modalOpen = true;
    },
    preDelete() {
      this.modalKey = Date.now();
      this.modalMode = "Delete";
      this.modalOpen = true;
      this.dropdownOpen = false;
    },
    selectPaymentMethod(id) {
      this.invoiceSettings.paymentMethodId = id;

      return invoiceAPIService
        .updateInvoiceSetting(
          this.invoiceSettings.id,
          this.invoiceSettings,
          this.$router,
        )
        .then(() => {
          this.getPaymentMethod();
        });
    },
  },
};
</script>

<style lang="scss">
.line {
  width: 100%;
}
.methodDropdown {
  position: absolute;
  top: 0;
  right: 0;
  background-color: white;
  padding: 10px;
  border-radius: 10px;
  z-index: 5;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.dropdownButton {
  background-color: #cfcfcf;
  padding: 5px 10px;
  color: #404040;
}
.changePaymentMethod {
  padding: 5px 10px;
}
.changePaymentMethod:hover {
  background-color: #cfcfcf;
  color: #404040;
  padding: 5px 10px;
  border-radius: 10px;
  cursor: pointer;
}
.paymentMethod {
  width: 100%;

  .paymentMethod_header {
    h1 {
      color: #404040;
      font-size: 35px;
      font-weight: 700;
      margin-bottom: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      font-family: Helvetica, Arial, sans-serif;
    }
  }

  .frameParent {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 20px 0px;
    gap: 15px;
    text-align: left;
    font-size: 15px;
    color: #404040;
    font-family: Helvetica, Arial, sans-serif;
  }

  .frameGroup {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 40px;
    font-size: 13px;
    color: rgba(64, 64, 64, 0.75);
  }

  .frameContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 40px;
    position: relative;
    border-top: rgba(64, 64, 64, 0.15) 2px solid;
    padding-top: 10px;
  }

  .dateWrapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 200px;
  }

  .date {
    position: relative;
  }

  .paymentMethod,
  .status,
  .div2 {
    position: relative;
    flex-shrink: 0;
  }

  .paymentMethod {
    width: 115px;
  }

  .status {
    width: 45px;
  }

  .div2 {
    width: 52px;
  }

  .frameChild {
    position: relative;
    max-width: 100%;
    overflow: hidden;
    max-height: 100%;
    align-self: stretch;
  }

  .dottedIcon {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
}
</style>
